module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-infinite-scroller/index.js
// module id = 1719
// module chunks = 25